import React from "react";
import classNames from "classnames";

import styles from "./FilterSelect.module.scss";

interface FilterSelectProps extends React.HTMLAttributes<HTMLSelectElement> {
  title?: string;
  value?: any;
  displayLabel?: any;
  className?: string;
}

const FilterSelect: React.FC<FilterSelectProps> = ({
  value,
  title,
  children,
  displayLabel,
  className,
  ...props
}) => {
  return (
    <label className={classNames(styles.label, className)}>
      {title && <span className={styles.title}>{title}</span>}
      <span className={styles.value}>{displayLabel || value}</span>
      <select className={styles.select} {...props}>
        {children}
      </select>
    </label>
  );
};

export { FilterSelect };
